// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14HGR","tabsBox":"styles_tabsBox__1Teh1","createButton":"styles_createButton__1Dbu-"};